<template>
  <u-dropdown :items="menuItems" :popper="placement ? {placement} : {}" @click.stop>
    <u-button
      :icon="COMMON_ICONS.moreVertical"
      :color="color"
      :variant="variant"
      :size="size"
      :aria-label="ariaLabel"
      :class="[triggerClass, frosted && 'border border-white/25 !rounded-xl !bg-black/10 !text-white shadow-md backdrop-blur-md hover:!bg-black/20']"
    />
  </u-dropdown>
</template>

<script setup>
  const emit = defineEmits(['change-cover', 'cover-designer', 'declutter']);

  defineProps({
    placement: String,
    triggerClass: String,
    ariaLabel: {
      type: String,
      default: 'Period actions'
    },
    color: {
      type: String,
      default: 'white'
    },
    variant: {
      type: String,
      default: 'outline'
    },
    size: {
      type: String,
      default: 'sm'
    },
    frosted: Boolean
  });

  const menuItems = [[
    {
      label: 'Change Cover',
      icon: COMMON_ICONS.makeCover,
      click: () => emit('change-cover')
    },
    // TODO: Restore the Cover Designer action when custom Timeline covers are ready.
    // {
    //   label: 'Cover Designer',
    //   icon: COMMON_ICONS.surfaceEditor,
    //   click: () => emit('cover-designer')
    // }

    {
      label: 'Declutter',
      icon: COMMON_ICONS.declutter,
      click: () => emit('declutter')
    }
  ]];
</script>
